// Example: "en-US"
// undefined - use user's locale
const locale = undefined;

interface AnalysisScoresProps {
  value: number;
  label: string;
  verdict: string;
  bgColor: string;
  className?: string;
}

export const AnalysisScore = ({
  label,
  value,
  verdict,
  bgColor,
  className = "",
}: AnalysisScoresProps) => {
  return (
    <div className={`flex flex-nowrap gap-2 ${className}`}>
      <div
        className={`flex flex-1 px-2 items-end rounded-[6px] ${bgColor} py-2 gap-1`}
      >
        <span className="font-ibm-plex-sans text-[12px] font-normal leading-[18px] text-[#FFFFFF88]">
          {label}
        </span>
        <span className="font-ibm-plex-sans text-[16px] font-medium leading-[20px]">
          {value.toLocaleString(locale, {
            maximumFractionDigits: 2,
          })}
        </span>
        <span className="font-ibm-plex-sans text-[12px] font-normal leading-[18px]">
          ({verdict})
        </span>
      </div>
    </div>
  );
};
